import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { trackPixelEvent } from '../lib/metaPixel';
import { offerIncludes } from '../data/landing';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/2xmifi1VBLwQzFH6daxgeb/Portada_Desintoxica_tu_Mente_en_21_Dias.jpg';
export function PricingSection() {
  return <section id="pricing" className="py-16 md:py-24 bg-white" data-id="element-109" data-mp="1jas38tnrut2l">
      <div className="max-w-4xl mx-auto px-6" data-id="element-110" data-mp="1na0spmbs44sc">
        <FadeIn data-id="element-111" data-mp="1s9dfk72nhbux">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal text-center mb-10" data-id="element-112" data-mp="1s8u8jlejg7vo">
            Todo lo que recibes
            <br data-id="element-113" data-mp="1x9hx80faocmq" />
            por $19.99
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-114" data-mp="226rx6a0b86ot">
          <div className="bg-white rounded-3xl border-2 border-brand-forest shadow-xl overflow-hidden" data-id="element-115" data-mp="2271lzu9mc7sx">
            <div className="grid md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]" data-id="element-116" data-mp="2ws3pjsu95fv">
              <div className="bg-brand-cream flex flex-col items-center justify-center px-8 py-8 md:py-10" data-id="element-117" data-mp="7ubshdn5x0m2">
                <img src={MOCKUP_URL} alt="Portada del eBook Desintoxica tu Mente en 21 Días" className="w-36 md:w-52 rounded-md shadow-lg mb-6" data-id="element-118" data-mp="1mhzhz9nawfax" />
                <div className="text-6xl font-serif font-bold text-brand-forest leading-none mb-3" data-id="element-119" data-mp="1cosbtmkqkv9s">
                  $19.99
                </div>
                <div className="text-sm text-brand-charcoal font-medium text-center" data-id="element-120" data-mp="25fsmggdkoxaf">
                  Pago único · Acceso digital inmediato
                </div>
              </div>

              <div className="p-6 md:p-10" data-id="element-121" data-mp="1vgtlljz1u5xz">
                <ul className="space-y-3 mb-8" data-id="element-122" data-mp="1vfs16ow5873l">
                  {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 text-brand-charcoal" data-id="element-123" data-mp="1rf857onb39j1">
                      <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-brand-forest flex items-center justify-center" data-id="element-124" data-mp="g02x254eois1">
                        <CheckIcon className="w-3 h-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-125" data-mp="hib11mhxa7nz" />
                      </span>
                      <span className="font-medium leading-snug" data-id="element-126" data-mp="7ly6kmejzps6">{item}</span>
                    </li>)}
                </ul>

                <a href="https://pay.hotmart.com/P106181864L?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('AddToCart', {
                content_name: 'Desintoxica tu Mente en 21 Días',
                content_type: 'product',
                currency: 'USD',
                value: 19.99
              })} className="block text-center w-full bg-brand-terracotta text-white py-4 px-5 rounded-full text-base sm:text-lg font-bold hover:bg-[#b05626] active:scale-[0.98] transition-[background-color,transform] duration-150 ease-out shadow-lg mb-3" data-id="element-127" data-mp="3uweg8lx6t1ve">
                  QUIERO EMPEZAR MIS 21 DÍAS — $19.99 →
                </a>

                <p className="text-center text-sm text-brand-gray mb-5" data-id="element-128" data-mp="369otwo5uxqg2">
                  Compra procesada de forma segura a través de Hotmart.
                </p>

                <p className="text-xs text-brand-gray italic text-center leading-relaxed" data-id="element-129" data-mp="3g8o3c8yg5q44">
                  Contenido educativo de bienestar. No sustituye diagnóstico,
                  tratamiento ni atención profesional.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-130" data-mp="3l17g53pb8h7v">
          <div className="mt-6 bg-brand-mint/40 border border-brand-mint rounded-2xl px-6 py-6 sm:px-8" data-id="element-131" data-mp="3l31t9vucb51e">
            <div className="flex flex-col sm:flex-row sm:items-start gap-4" data-id="element-132" data-mp="3u1dsgm99vb5g">
              <span className="flex-shrink-0 w-11 h-11 rounded-full bg-white flex items-center justify-center" aria-hidden="true" data-id="element-133" data-mp="3tz9e1adqytqx">
                <ShieldCheckIcon className="w-6 h-6 text-brand-forest" data-id="element-134" data-mp="ly4onbbh90h4" />
              </span>
              <div data-id="element-135" data-mp="qrpdodv3ek46">
                <h3 className="font-serif font-bold text-brand-forest text-lg tracking-wide mb-2" data-id="element-136" data-mp="qr64pmnf762a">
                  GARANTÍA DE 7 DÍAS
                </h3>
                <p className="text-brand-charcoal leading-relaxed text-sm sm:text-base" data-id="element-137" data-mp="3v5e6ealnpt6i">
                  Queremos que empieces con tranquilidad. Si después de adquirir
                  «Desintoxica tu Mente en 21 Días» decides que la guía no es
                  para ti, puedes solicitar un reembolso dentro del período de
                  garantía de 7 días, de acuerdo con las condiciones de Hotmart.
                </p>
                <p className="text-xs text-brand-gray mt-3" data-id="element-138" data-mp="1jejun0spb1cw">
                  Compra procesada a través de Hotmart.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}